var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"laonlttlay"},[_c('sec-title',{staticClass:"text_center",attrs:{"Text":"特推律师","descText":"合肥律师在线咨询 ，快速解决您的法律问题"}}),_c('onadv-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }